export const backUrl = "https://ums-karabalta-b.get.kg/api/"
export const LOCAL_STORAGE_USER_KEY = "AIS_ARENDA_USER_KEY"
// "http://subactiv.sytes.net:1337/api/"
// "8c4a7ecf9805fa82b0db77d3eeadca211fe136bd21761de9d621a05949b31bca5cc32f90aff18db5f6540b3744b6f59ad8bcdcfd1da5c06c5ed58cf4e20ab209ffb30a5e122cd0f5023968320b87c6ce9a3e2b0db4108ec8519cc9ae0ea3e5393fd73614db3242ee9a00b4cc24adc2aade73048ef6f78d69d3cc6818adeff3bb"
